import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string, putObject: Request): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Status/${id}`;
	return axios.put(url, putObject).toOptionalVoid();
}

export interface Request {
	order: number;
	color: string;
	nameTranslations: {
		[key: string]: string;
	};
}
